module.exports = __webpack_public_path__ + "img/logo.2a1e3dda.png";